import React, { useState, useEffect } from 'react';
import { Router } from '@reach/router'
import Product from './containers/Product'
import Client from './containers/Client'
import PaymentWay from './containers/PaymentWay'
import NotFound from './components/NotFound'
import Loading from './components/Loading'

function App({ config }: any) {
  const [widget, setWidget] = useState({ concepts: [] })
  const [paymentWays, setPaymentWays] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  const [tokenExpired, setTokenExpired] = useState(false)
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    const url = process.env.REACT_APP_API_URL

    if (config.key) {
      fetch(`${url}/widget/configuration`, {
        method: 'POST',
        body: JSON.stringify(config),
        headers: {
          'Content-Type': 'application/json'
        },
      })
        .then(response => {
          if (response.ok) {
            response.json()
              .then((data) => {
                setIsLoading(false)
                setWidget(data)
              })
          } else {
            setIsLoading(false)
            setTokenExpired(true)
          }
        })
        .catch((response) => {
          console.log(response)
          setIsLoading(false)
          setHasError(true)
        })
    }
  }, [config])

  const context = process.env.PUBLIC_URL
  return (
    <Router>
      {(!!config.key && !isLoading && !tokenExpired) && (<>
        <Product
          path={`${context ? context : '/'}`}
          widget={{ ...widget, key: config.key }}
        />
        <Client
          path={`${context}/client`}
          token={config.key}
          setPaymentWays={setPaymentWays}
        />
        <PaymentWay path={`${context}/gateways`} paymentWays={paymentWays} />
      </>)}
      {isLoading && <Loading default />}
      {(!config.key || tokenExpired || hasError) && <NotFound default />}
    </Router>
  );
}

export default App;
